import api from './api';
import { Urlaub, UrlaubCreate, UrlaubSettings, UrlaubZusammenfassung, UrlaubUebersichtResponse } from '../types';

export interface UrlaubListenOptionen {
  /** Offene Anträge (Beantragt) anderer Jahre zusätzlich zum Jahresfilter liefern. */
  offeneAndereJahre?: boolean;
}

export const urlaubService = {
  /** List own vacation requests */
  list: async (jahr?: number, options?: UrlaubListenOptionen): Promise<Urlaub[]> => {
    const params: Record<string, unknown> = {};
    if (jahr != null) params.jahr = jahr;
    if (options?.offeneAndereJahre) params.offene_andere_jahre = true;
    const response = await api.get('/urlaub/', { params });
    return response.data;
  },

  /** Management: Get vacation overview for all employees */
  uebersicht: async (jahr?: number): Promise<UrlaubUebersichtResponse> => {
    const params: Record<string, unknown> = {};
    if (jahr) params.jahr = jahr;
    const response = await api.get('/urlaub/uebersicht', { params });
    return response.data;
  },

  /** Admin: List all vacation requests */
  listAlle: async (jahr?: number, status?: string, options?: UrlaubListenOptionen): Promise<Urlaub[]> => {
    const params: Record<string, unknown> = {};
    if (jahr != null) params.jahr = jahr;
    if (status) params.status = status;
    if (options?.offeneAndereJahre) params.offene_andere_jahre = true;
    const response = await api.get('/urlaub/alle', { params });
    return response.data;
  },

  /** Get vacation summary for current user */
  zusammenfassung: async (jahr?: number): Promise<UrlaubZusammenfassung> => {
    const params: Record<string, unknown> = {};
    if (jahr) params.jahr = jahr;
    const response = await api.get('/urlaub/zusammenfassung', { params });
    return response.data;
  },

  /** Create a new vacation request */
  create: async (data: UrlaubCreate): Promise<Urlaub> => {
    const response = await api.post('/urlaub/', data);
    return response.data;
  },

  /** Update own vacation request (only if status is 'Beantragt') */
  update: async (id: number, data: Partial<UrlaubCreate>): Promise<Urlaub> => {
    const response = await api.put(`/urlaub/${id}`, data);
    return response.data;
  },

  /** Delete own vacation request (only if status is 'Beantragt') */
  remove: async (id: number): Promise<void> => {
    await api.delete(`/urlaub/${id}`);
  },

  /** Admin: Approve a vacation request */
  genehmigen: async (id: number, adminBemerkung?: string): Promise<Urlaub> => {
    const response = await api.put(`/urlaub/${id}/genehmigen`, {
      admin_bemerkung: adminBemerkung || null,
    });
    return response.data;
  },

  /** Admin: Reject a vacation request */
  ablehnen: async (id: number, adminBemerkung?: string): Promise<Urlaub> => {
    const response = await api.put(`/urlaub/${id}/ablehnen`, {
      admin_bemerkung: adminBemerkung || null,
    });
    return response.data;
  },

  /** Admin: Globale Urlaubs-Einstellungen */
  getEinstellungen: async (): Promise<UrlaubSettings> => {
    const response = await api.get('/urlaub/einstellungen');
    return response.data;
  },

  updateEinstellungen: async (data: Partial<UrlaubSettings>): Promise<UrlaubSettings> => {
    const response = await api.put('/urlaub/einstellungen', data);
    return response.data;
  },
};
